// Crash reporting for the admin "Hata kayıtları" page. Never throws and never floods the server.
let sent = 0;
const seen = new Set<string>();

export function reportError(err: unknown, where: string, game?: string): void {
  try {
    const e = err instanceof Error ? err : new Error(typeof err === 'string' ? err : JSON.stringify(err));
    const key = `${where}|${e.message}`;
    if (sent >= 15 || seen.has(key)) return;
    seen.add(key);
    sent++;
    void fetch('/api/telemetry/error', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ message: e.message || 'Hata', stack: e.stack, url: location.pathname, where, game }),
      keepalive: true,
    }).catch(() => undefined);
  } catch {
    /* reporting must never cause a second crash */
  }
}

/** Uncaught errors and rejected promises anywhere in the app. */
export function installGlobalErrorReporting(): void {
  window.addEventListener('error', (ev) => reportError(ev.error ?? ev.message, 'window'));
  window.addEventListener('unhandledrejection', (ev) => reportError(ev.reason, 'promise'));
}
